//#region src/components/CenteredContentLayout/CenteredContentLayout.module.css
var e = "_container_vfw8c_1", t = { container: e };
//#endregion
export { e as container, t as default };
